<template>
  <validation-provider
    :rules="`image_url:${allowedFormat.join(',')}`"
    v-slot="{ errors }"
    :name="$t('partners.details.settings.customization.logo.title')"
  >
    <v-card flat>
      <v-card-subtitle class="pl-0 font-weight-bold">
        {{ $t('partners.details.settings.customization.logo.title') }}
      </v-card-subtitle>
      <v-card-text class="pl-0">
        <v-text-field
          hide-details="auto"
          class="text-uppercase"
          outlined
          dense
          v-model="logo"
          :label="$t('partners.details.settings.customization.logo.input')"
          :error-messages="errors"
          clearable
          type="text"
        />
      </v-card-text>
      <v-card outlined tile v-show="textExists(logo) && errors.length <= 0">
        <div class="d-flex justify-space-around ma-1">
          <v-img max-height="150" max-width="300" :src="logo" contain />
        </div>
      </v-card>
      <v-card-text class="pl-0">
        <p class="ma-0">
          {{ $t('partners.details.settings.customization.logo.format') }} : {{ allowedFormat.join(', ') }}
        </p>
      </v-card-text>
    </v-card>
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { textExists } from '../../helpers/helper'

  export default {
    name: 'LogoSelector',
    components: {
      ValidationProvider,
    },
    props: {
      value: {
        type: String,
        default: undefined,
      },
    },
    data() {
      return {
        allowedFormat: ['PNG', 'JPG', 'SVG'],
      }
    },
    computed: {
      logo: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      textExists,
    },
  }
</script>
